/* eslint-disable react/no-array-index-key */
import React from 'react';
import style from './Breadcrumbs.module.css';

const Breadcrumbs = (props) => {
  let crumbs = [];
  crumbs = crumbs.concat(props.children);
  crumbs = crumbs.map((element, index) => (
    <React.Fragment key={index}>
      <li className="crumb">
        {element}
      </li>
      { index !== crumbs.length - 1
        && (
          <li className="crumb" key={`${index}e`}>
            <i className="icon fas fa-chevron-right" />
          </li>
        )}
    </React.Fragment>
  ));

  return (
    <div className={`${style.Breadcrumbs} Breadcrumbs `}>
      <span>Fluxo em edição: </span>
      <ul className="crumb-list">
        {crumbs}
      </ul>
    </div>
  );
};

export default Breadcrumbs;
